import { useState, useEffect } from "react";
import styled from "styled-components";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import BlogItem from "./BlogItem";
import { TBlog } from "@/pages/api/admin/blog";

async function fetchBlogItems(page: number = 0, limit: number = 4): Promise<TBlog[]> {
  const fetchResult = await fetch("/api/blog/list", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ page, limit }),
  });

  const result = await fetchResult.json();
  return result.result;
}

export default function Blog() {
  const [blogItems, setBlogItems] = useState<TBlog[]>([]);

  const { t } = useTranslation();

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const blogs = await fetchBlogItems(0, 4);
        setBlogItems(blogs);
      } catch (error) {
        console.error(`error : ${error}`);
      }
    };

    loadBlogs();
  }, []);

  return (
    <BlogWrap>
      <TitleWrap>
        <Title data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100" data-aos-duration="500">
          {t("learn.blog.title")}
        </Title>
        <Button href="/learn/blog">{t("main.blog.view-all-posts")}</Button>
      </TitleWrap>
      <ContentWrap>
        {Array.isArray(blogItems) && blogItems.length > 0 ? (
          blogItems.map((item) => <BlogItem key={item.id} id={item.id} bg={item.bg} title={item.title} />)
        ) : (
          <>{t("main.blog.not-found-blog-posts")}</>
        )}
      </ContentWrap>
    </BlogWrap>
  );
}

const BlogWrap = styled.div`
  padding: 0 32px;
  box-sizing: border-box;
`;
const TitleWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 55px 0;
  padding: 0 16px;
  box-sizing: border-box;
`;
const Title = styled.p`
  width: 100%;
  font-size: 2.7rem;
  font-weight: 800;
  color: black;
  display: flex;
  justify-content: space-between;
`;
const Button = styled(Link)`
  border-radius: 20px;
  width: 200px;
  height: 40px;
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: center;
  background-color: black;
  color: white;
  cursor: pointer;
  transition: 0.3s ease-out;
  &:hover {
    background-color: white;
    color: black;
    transition: 0.3s ease-out;
  }
`;
const ContentWrap = styled.div`
  width: 100%;
  height: 738px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 1000px) {
    margin: 0 0 50px 0;
    height: initial;
  }
`;
